import { Avatar } from '@material-ui/core';
import styled from 'styled-components';
import { GIT_PROVIDERS, TEAM_TYPES } from 'common/constants/constants';
import SyncedIndicator from 'components/SyncedIndicator/SyncedIndicator';
import Text from './Text';

const sizes = {
  small: {
    avatarSize: '2.2rem',
    borderWidth: '2px',
    fontSize: '0.8rem',
    syncedIconSize: 'x-small'
  },
  medium: {
    avatarSize: '3rem',
    borderWidth: '2px',
    fontSize: '1rem',
    syncedIconSize: 'smaller'
  },
  large: {
    avatarSize: '3.3rem',
    borderWidth: '2px',
    fontSize: '1.2rem',
    syncedIconSize: 'smaller'
  }
};

const StyledAvatar = styled(Avatar)`
  width: ${({ size }) => `${sizes[size].avatarSize} !important`};
  height: ${({ size }) => `${sizes[size].avatarSize} !important`};
  > p {
    font-size: ${({ size }) => `${sizes[size].fontSize}`};
  }
`;

const AvatarWrapper = styled.div`
  position: relative;
`;

const GroupAvatar = styled(Avatar)`
  width: ${({ size }) => `calc(${sizes[size].avatarSize} - 4px) !important`};
  height: ${({ size }) => `calc(${sizes[size].avatarSize} - 4px) !important`};
  background-color: white !important;
  border: ${({ color }) => `2px solid ${color}`};
  > p {
    font-size: ${({ size }) => `${sizes[size].fontSize}`};
  }
`;

const AvatarBadge = styled.div`
  position: absolute;
  bottom: 0;
  right: -0.5rem;
  display: flex;
  background: white;
  border-radius: 50%;
  padding: 1px;
`;

const AvatarRipple = styled.div`
  position: absolute;
  top: 0;
  right: ${({ order }) => `calc(-1 * ${order * 3}px)`};
  opacity: ${({ order }) => `calc(1 - 0.333 * ${order})`};
  width: ${({ size }) => `calc(${sizes[size].avatarSize} - 4px)`};
  height: ${({ size }) => `calc(${sizes[size].avatarSize} - 4px)`};
  border-radius: 50%;
  background-color: white;
  border: ${({ color }) => `2px solid ${color}`};
`;

const TeamAvatar = ({ team, size = 'medium' }) => {
  if (!sizes[size]) {
    return null;
  }

  const {
    color,
    initials,
    children = [],
    isSynced = false,
    isParent = false,
    type
  } = team;
  const isGroup =
    children.length > 0 ||
    isParent ||
    type === TEAM_TYPES.GROUP ||
    type === TEAM_TYPES.ALL_TEAMS;
  return (
    <AvatarWrapper className='avatar'>
      {isGroup ? (
        <>
          <AvatarRipple color={color} size={size} order={2} />
          <AvatarRipple color={color} size={size} order={1} />
          <GroupAvatar color={color} size={size}>
            <Text weight='bold' style={{ color }}>
              {initials}
            </Text>
          </GroupAvatar>
        </>
      ) : (
        <StyledAvatar style={{ backgroundColor: team.color }} size={size}>
          <Text weight='bold' color='white'>
            {initials}
          </Text>
        </StyledAvatar>
      )}
      {isSynced && (
        <AvatarBadge>
          <SyncedIndicator
            gitProviderId={GIT_PROVIDERS.GITHUB}
            size={sizes[size].syncedIconSize}
          />
        </AvatarBadge>
      )}
    </AvatarWrapper>
  );
};

export default TeamAvatar;
